import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router';
import { responseLogWithNotification } from '../../../utils/utils';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME } from '../../../configs';
import { dateFormatter, infoFormatterIntl } from '../../../utils/formatters';
import { loadVehicleRegistryById } from '../../VehicleRegistry/actions';
import { getVehicleRegistryData } from '../../VehicleRegistry/reducer';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function TransportDetailsPopUp(props) {
  const {
    id,
  } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    currentVehicleRegistry = {},
    loadingCurrentVehicleRegistry,
  } = useSelector(getVehicleRegistryData);

  const {
    updated_at,
    vehicle_brand,
    vehicle_model,
    vehicle_vin,
    vehicle_color,
    registry_vehicle = {},
    vehicle_lpn,
  } = currentVehicleRegistry;

  useEffect(() => {
    dispatch(loadVehicleRegistryById(id)).catch(responseLogWithNotification);
  }, []);

  return (
    <div className={classNames('full-view custom-scroll-theme')}>
      <TimerLoader loading={loadingCurrentVehicleRegistry} />
      <div className="full-view-header">
        <div>{formatMessage({ id: 'driver.card.menu.transport.details' })}</div>
        <Icons onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.TRANSPORT_DETAIL, id })))} customIcon icon="close" />
      </div>
      <div className="full-view-content">
        <Row className="row-cols-2">
          {infoFormatterIntl('vehicle_brand', vehicle_brand, {}, 'brand')}
          {infoFormatterIntl('vehicle_model', vehicle_model, {}, 'model')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('vehicle_color', vehicle_color, {}, 'inn')}
          {infoFormatterIntl('grn_ts', vehicle_lpn, {}, 'ogrn')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('vehicle_vin', vehicle_vin, {}, 'vehicle_vin')}
          {infoFormatterIntl('visit.record_number_lt', <NavLink target="_blank" to={`/region-registry/passenger-taxi?registry_id=${registry_vehicle?.id}`}>{registry_vehicle?.number}</NavLink>, {}, 'registry_vehicle.number')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('created_at', dateFormatter(updated_at), {}, 'updated_at')}
          {infoFormatterIntl('vehicle_year', registry_vehicle?.vehicle_year, {}, 'registry_vehicle.vehicle_year')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('has_special_lifting_device', registry_vehicle?.has_special_lifting_device ? 'Есть' : 'Нет', {}, 'has_special_lifting_device')}
          {infoFormatterIntl('vehicle_registration_number', registry_vehicle?.vehicle_registration_number, {}, 'registry_vehicle.vehicle_registration_number')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('is_illegal', currentVehicleRegistry?.is_illegal ? 'Нелегально' : 'Легально', {}, 'is_illegal')}
          {infoFormatterIntl('illegal_reasons', (currentVehicleRegistry?.illegal_reasons || [])?.map(item => item?.message).join(','), {}, 'first_name')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('vehicle_registration_issue_date', dateFormatter(registry_vehicle?.vehicle_registration_issue_date), {}, 'registry_vehicle.vehicle_registration_issue_date')}
        </Row>
        {/* <Accordion */}
        {/*  title="Дополнительная информация" */}
        {/*  isOpen */}
        {/*  content={( */}
        {/*    <> */}
        {/*      <Row className="row-cols-2"> */}
        {/*        {infoFormatterIntl('insurance_contract_series', registry_vehicle?.insurance_contract_series, {}, 'registry_vehicle.insurance_contract_series')} */}
        {/*        {infoFormatterIntl('insurance_contract_number', registry_vehicle?.insurance_contract_number, {}, 'registry_vehicle.insurance_contract_number')} */}
        {/*      </Row> */}
        {/*      <Row className="row-cols-2"> */}
        {/*        {infoFormatterIntl('effective_date', dateFormatter(registry_vehicle?.insurance_contract_effective_date), {}, 'registry_vehicle.effective_date')} */}
        {/*        {infoFormatterIntl('expiration_date', dateFormatter(registry_vehicle?.insurance_contract_expiration_date), {}, 'registry_vehicle.expiration_date')} */}
        {/*      </Row> */}
        {/*      <Row className="row-cols-1"> */}
        {/*        {infoFormatterIntl('technical_control_address', registry_vehicle?.technical_control_address, {}, 'registry_vehicle.technical_control_address')} */}
        {/*      </Row> */}
        {/*    </> */}
        {/*  )} */}
        {/* /> */}
      </div>
    </div>
  );
}
